module.exports = __webpack_public_path__ + "img/8.BP.2d716754.jpg";